<template>
    <div class="mx-3">
        <archive-claim-confirmation @confirm="archive"></archive-claim-confirmation>
        <filter-claims-modal></filter-claims-modal>
        <div class="d-flex justify-content-between align-items-end border-bottom">
            <h2>{{ client.name }}</h2>
            <div class="btn-toolbar mb-1" role="toolbar">
                <div class="input-group mr-2">
                    <div class="input-group-prepend">
                        <button class="btn dropdown-toggle input-group-text" type="button" data-toggle="dropdown">{{ searchOption.name }}</button>
                        <div class="dropdown-menu">
                            <button v-for="option in searchOptions" :key="'search-option-' + option.id" class="dropdown-item text-primary" @click="searchOption = option">{{ option.name }}</button>
                        </div>
                    </div>                    
                    <input ref="searchInput" type="text" class="form-control" :placeholder="searchOption.placeholder" v-model="searchString" @keyup.enter="search()">
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="search()"><i class="fas fa-search fa-lg"></i></button>
                    </div>                    
                </div>
                <div class="btn-group">
                    <!-- <button type="button" class="btn btn-primary" data-toggle="tooltip" title="Filter" @click="showFilters">
                        <i class="fas fa-filter fa-lg"></i>
                    </button> -->
                    <a :href="'/attorney/clients/' + client.id + '/archive/claims'" class="btn btn-primary" data-toggle="tooltip" title="Archived Claim List">
                        <i class="fas fa-archive fa-lg"></i>                   
                    </a>
                </div>
            </div>            
        </div>
        <div v-if="claims.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th>Docket Number(s)</th>
                        <th>Claim Number</th>
                        <th>Patient Name</th> 
                        <th>Date of Injury</th>                                 
                        <th>Provider</th>
                        <th>Payer</th>
                        <th>Shared</th>
                        <th class="text-right"><div class="multiline-header">Estimated<br />Reimbursement</div></th>
                        <th class="text-right">Balance</th>
                        <th></th>
                    </tr>                    
                </thead>
                <tbody>
                    <tr v-for="claim in claims" :key="'claim-' + claim.id">
                        <td>
                            <i v-if="claim.status === 'Attention'" class="fas fa-exclamation-triangle fa-lg text-warning" :title="claim.status"></i>
                            <i v-else class="fas fa-fw fa-lg"></i>               
                        </td>
                        <td>{{ claim.docket_numbers }}</td>
                        <td><a :href="getClaimHref(claim.id)">{{ claim.claim_number }}</a></td>
                        <td><a :href="getClaimHref(claim.id)">{{ claim.patient_name }}</a></td>
                        <td>{{ claim.injury_date }}</td>
                        <td>{{ claim.rendering_provider_name }}</td>
                        <td>{{ claim.legal_payer_name || claim.provider_payer_name }}</td>
                        <td>{{ claim.shared_at }}</td>
                        <td class="text-right">{{ claim.estimated_reimbursement | currency }}</td>
                        <td class="text-right">{{ claim.balance | currency }}</td>
                        <td>
                            <div class="d-flex flex-nowrap flex-row justify-content-end">

                                <div class="text-center">
                                    <button class="btn btn-link btn-sm py-0 px-1" title="Archive Claim" @click="showArchiveConfirmation(claim.shared_attorney_claim_id)">
                                        <div class="fa-stack">
                                            <i class="fas fa-archive fa-stack-1x"></i>
                                            <i class="fas fa-arrow-circle-down fa-stack-1x fa-inverse archive-icon"></i>
                                        </div> 
                                    </button>
                                </div>

                            </div>                            
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex">
                <nav v-if="pageCount > 1" aria-label="Page navigation">
                    <ul class="pagination">
                        <li :class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="first()">
                                <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                        <li :class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="previous()">
                                <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="next()">
                                <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="last()">
                                <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                    </ul>
                </nav>
                <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
            </div>
                                     
        </div>
        <div v-else-if="isLoading" class="pt-3">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>
        <div v-else class="pt-3">
            <h2 class="text-muted text-center">No active claims.</h2>
        </div>         
    </div>    
</template>

<script>
import FilterClaimsModal from './FilterClaimsComponent.vue';
import ArchiveClaimConfirmation from '../ArchiveClaimConfirmationComponent.vue';

export default {
    components: {
        ArchiveClaimConfirmation,
        FilterClaimsModal
    },
    props: {
        client: Object,
        searchOptions: Array,
        selectedSearchOptionId: Number,
        searchText: String,
        page: Number        
    },
    data() {
        return {
            claims: [],
            searchOption: this.searchOptions.find(x => x.id === this.selectedSearchOptionId),
            searchString: this.searchText,
            currentPage: this.page,            
            pageCount: 0,
            isLoading: false,
            filters: {
                status_id: -1
            }                  
        }
    },
    methods: {
        refresh: function () {
            this.isLoading = true;

            let url = `/ajax/attorney/clients/${this.client.id}/claims`;
            axios.get(url, {
                params: {
                    'search_option_id': this.searchOption.id,
                    'search_string': this.searchString,
                    'page': this.currentPage - 1
                }
            })
            .then(response => {
                this.claims = response.data.claims;
                this.pageCount = response.data.page_count;
                this.isLoading = false;
            })
            .catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        search: function () {
            this.currentPage = 1;
            this.refresh();
        },        
        first: function () {
            if (this.currentPage > 1) {
                this.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.currentPage < this.pageCount) {
                this.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.currentPage < this.pageCount) {
                this.currentPage = this.pageCount;
                this.refresh();
            }
        },         
        showFilters: function () {
            //eventHub.$emit('show-claim-filters', this.statusOptions, this.filters, this.filter);
        },
        filter: function (filters) {
            this.filters = filters;
        },
        showArchiveConfirmation: function (id) {
            eventHub.$emit('show-archive-confirmation', id);
        },
        archive: function (id, note) {
            axios.patch('/ajax/attorney/clients/' + this.client.id + '/claims/' + id, {
                note: note
            })
            .then(response => {
                // nothing to do; event will update ui 
            })
            .catch(error => {
                toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            });
        },
        getClaimHref: function (claimId) {

            let url = new URL(window.location.origin + `/attorney/claims/${claimId}`);

            url.searchParams.append('searchOptionId', this.searchOption.id);
            url.searchParams.append('searchString', this.searchString);
            url.searchParams.append('page', this.currentPage);

            return url.href;
        },              
    },
    created() {
        this.refresh();

        window.Echo.private('shared-claim-event.' + this.client.id)
            .listen('SharedClaimEvent', (e) => {
                this.refresh(); 
            });        
    },
    mounted() {        
        this.$refs.searchInput.setAttribute('size', this.$refs.searchInput.getAttribute('placeholder').length);
    }          
}
</script>

<style scoped>
    .archive-icon {
        padding-top: 3px;
        font-size: .85em;
    }
</style>